// Translations for CryptoBot Trading App
// Supported languages: French (fr), English (en)

const translations = {
  fr: {
    // Common
    common: {
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      save: 'Enregistrer',
      copy: 'Copier',
      copied: 'Copié !',
      close: 'Fermer',
      back: 'Retour',
      next: 'Suivant',
      yes: 'Oui',
      no: 'Non',
      active: 'Actif',
      inactive: 'Inactif',
      verified: 'Vérifié',
      allRightsReserved: 'Tous droits réservés',
      seeAll: 'Voir tout',
      portfolioValue: 'Valeur du Portefeuille',
    },

    // Navigation
    nav: {
      home: 'Accueil',
      markets: 'Marchés',
      trading: 'Trading',
      wallet: 'Wallet',
      profile: 'Profil',
      messages: 'Messages',
    },

    // Auth
    auth: {
      login: 'Se connecter',
      loginTitle: 'Connectez-vous à votre compte',
      register: 'Créer mon compte',
      registerTitle: 'Créez votre compte',
      logout: 'Se déconnecter',
      email: 'Email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      username: 'Nom d\'utilisateur',
      referralCode: 'Code de parrainage',
      optional: 'optionnel',
      referralHint: 'Si vous avez un code parrain, entrez-le pour gagner des bonus !',
      forgotPassword: 'Mot de passe oublié ?',
      noAccount: 'Pas encore de compte ?',
      hasAccount: 'Déjà un compte ?',
      createAccount: 'Créer un compte',
      loginSuccess: 'Connexion réussie',
      registerSuccess: 'Inscription réussie',
      invalidCredentials: 'Email ou mot de passe incorrect',
      loggingIn: 'Connexion...',
      creating: 'Création...',
      signupBonus: '',
      verifyTitle: 'Vérification de votre email',
      verifyAdminTitle: 'Code de connexion administrateur',
      verifySentTo: 'Un code à 6 chiffres a été envoyé à',
      verifyCodeLabel: 'Code de vérification',
      verifyExpiresIn: 'Expire dans',
      verifyExpired: 'Ce code a expiré — demandez-en un nouveau',
      verifySubmit: 'Vérifier',
      verifyChecking: 'Vérification...',
      verifyResend: 'Renvoyer le code',
      verifyResendWait: 'Renvoyer dans',
      verifyResendSuccess: 'Nouveau code envoyé',
      verifyBackToLogin: 'Retour à la connexion',
      forgotPasswordTitle: 'Mot de passe oublié',
      forgotPasswordHint: 'Indiquez votre email, nous vous enverrons un code pour réinitialiser votre mot de passe.',
      forgotPasswordSubmit: 'Envoyer le code',
      forgotPasswordReset: 'Réinitialiser le mot de passe',
      passwordResetSuccess: 'Mot de passe réinitialisé — connectez-vous avec votre nouveau mot de passe',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      passwordTooShort: 'Le mot de passe doit faire au moins 8 caractères',
      usernameTooShort: 'Le nom d\'utilisateur doit faire au moins 3 caractères',
      pwdRuleLength: 'Au moins 8 caractères',
      pwdRuleUpper: 'Une lettre majuscule (A-Z)',
      pwdRuleLower: 'Une lettre minuscule (a-z)',
      pwdRuleNumber: 'Un chiffre (0-9)',
      pwdRuleSpecial: 'Un caractère spécial (!@#$…)',
      strengthWeak: 'Faible',
      strengthMedium: 'Moyen',
      strengthStrong: 'Fort',
      usernameMinError: 'Au moins 3 caractères',
      emailInvalid: 'Adresse email invalide',
      passwordsMatchOk: 'Les mots de passe correspondent ✓',
      referralValid: 'Code de parrainage valide',
      referralCounter: '{n}/8 caractères',
      referralRequired: 'Un code de parrainage est obligatoire pour créer un compte',
      referralInvalid: 'Code de parrainage invalide',
      checkUsername: 'Nom d\'utilisateur (min 3 car.)',
      checkEmail: 'Email invalide',
      checkPassword: 'Mot de passe incomplet',
      checkPasswordsMatch: 'Mots de passe différents',
    },

    // Dashboard
    dashboard: {
      totalBalance: 'Solde total',
      variation: 'Variation',
      quickStats: 'Statistiques rapides',
      welcomeReferredTitle: 'Bienvenue sur CryptoBot !',
      welcomeReferredBody: 'Vous avez été parrainé par {name}. Rechargez votre compte pour commencer à trader et profiter de vos gains.',
      welcomeReferredContactLine: 'Contactez {name} sur {email}',
      welcomeReferredContactLineNoEmail: 'Contactez {name} via la messagerie',
      welcomeReferredRecharge: 'Recharger mon compte',
      welcomeReferredContact: 'Contacter le support',
      nudgeReferrerTitle: 'Accompagnez votre filleul',
      nudgeReferrerBody: '{name} n\'a pas encore rechargé son compte — invitez-le à investir pour recevoir votre bonus de parrainage !',
      wonTrades: 'Trades Gagnés',
      pending: 'En Attente',
      successRate: 'Taux de Succès',
      topCryptos: 'Top Cryptos',
      dailyChart: 'Graphique du jour',
      tradingBot: 'Bot de Trading',
      botActive: 'Actif',
      botAnalyzing: 'Analyse en cours...',
      scanningMarkets: 'Scan des marchés crypto',
      botMessage: 'Le bot analyse les tendances et vous enverra des opportunités de trading optimales.',
      botSignalValidated: 'Signal validé',
      botSignalRejected: 'Écarté',
      botMarketsAnalyzed: 'marchés analysés',
      botScanning: 'Analyse',
      viewSuggestions: 'Voir les Suggestions',
      goToTrading: 'Aller au Trading',
      goToWallet: 'Aller au Wallet',
      capitalToInvest: 'Capital à investir',
      invest: 'Investir',
    },

    // Markets
    markets: {
      title: 'Marchés',
      search: 'Rechercher une crypto...',
      price: 'Prix',
      change24h: 'Variation 24h',
      volume: 'Volume 24h',
      marketCap: 'Market Cap',
      allCryptos: 'Toutes les cryptos',
      pricesAutoUpdate: 'Les prix sont mis à jour automatiquement toutes les 30 secondes',
      tools: 'Outils',
      toggleTools: 'Afficher / masquer les outils de dessin',
    },

    // Trading
    trading: {
      suggestions: 'Suggestions',
      inProgress: 'En Cours',
      completed: 'Terminés',
      missed: 'LOUPÉ',
      accept: 'Accepter',
      reject: 'Refuser',
      potentialGain: 'Gain potentiel',
      duration: 'Durée',
      amount: 'Montant',
      startsIn: 'Démarre dans',
      expired: 'Écoulé',
      noSuggestions: 'Aucune suggestion pour le moment',
      noActiveTrades: 'Aucune position active',
      noActivePosDesc: 'Acceptez une suggestion pour ouvrir une position de trading.',
      noCompletedTrades: 'Aucun trade terminé',
      tradeAccepted: 'Trade accepté',
      tradeRejected: 'Trade refusé',
      missedTrade: 'Opportunité manquée',
      youCouldHaveWon: 'Vous auriez pu gagner',
      tradeSuccess: 'Trade réussi',
      youWon: 'Vous avez gagné',
      buy: 'ACHAT',
      sell: 'VENTE',
      validated: 'VALIDÉ',
      pending: 'EN ATTENTE',
      invested: 'Investi',
      gain: 'Gain',
      gainsPaid: 'Gains versés',
      lossPaid: 'Résultat versé',
      closed: 'CLÔTURÉ',
      live: 'EN COURS',
      tradeEnded: 'Trade terminé',
      timeRemaining: 'Temps restant',
      progression: 'Progression',
      investedAmount: 'Montant investi',
      entryPrice: 'Prix d\'entrée',
      currentPrice: 'Prix actuel',
      currentGain: 'Gain actuel',
      tradeExecuting: 'Trade en cours d\'exécution',
      gainsAutomatic: 'Les gains seront versés automatiquement à la clôture',
      waitingNext: 'En attente de la prochaine opportunité...',
      suggestionsPerDay: 'Signaux/jour',
      averageGain: 'Gain moyen',
      howItWorks: 'Comment ça marche ?',
      step1Title: 'Suggestion',
      step1Desc: 'Le bot propose un trade',
      step2Title: 'Validation',
      step2Desc: 'Vous acceptez ou refusez',
      step3Title: 'Résultat',
      step3Desc: 'Gains versés à la clôture',
      acceptError: 'Erreur lors de l\'acceptation',
      rejectError: 'Erreur lors du refus',
      signalsToday: 'Signaux aujourd\'hui',
    },

    // Wallet
    wallet: {
      title: 'Portefeuille',
      totalBalance: 'Solde Total',
      deposit: 'Dépôt',
      withdraw: 'Retrait',
      myAssets: 'Mes actifs',
      performance: 'Performance',
      projections: 'Projections',
      history: 'Historique',
      noTransactions: 'Aucune transaction',
      noTransactionsDesc: 'Votre historique de trades apparaîtra ici une fois que vous aurez commencé à trader.',
      projectionDisclaimer: 'Estimations basées sur les conditions actuelles. Les résultats réels peuvent différer.',
      profit: 'Profit',
      trades: 'Trades',
      successRate: 'Taux de réussite',
      bestTrade: 'Meilleur trade',
      overview: 'Vue d\'ensemble',
      usDollar: 'Tether USD',
      cryptoHint: 'Vos cryptos achetées apparaîtront ici',
      variation: 'Variation',
      chartHint: 'Touchez le graphique pour voir les détails',
      growthForecast: 'Prévision de croissance',
      noWithdrawalEstimate: 'Estimation si vous ne faites aucun retrait',
      month1: '1 Mois',
      month3: '3 Mois',
      month6: '6 Mois',
      currentBalance: 'Solde actuel',
      target: 'Objectif',
      estimatedGain: 'Gain potentiel estimé',
      balance: 'Solde',
      securedFunds: 'Fonds sécurisés',
      smartTrading: 'Trading intelligent',
      now: 'Maintenant',
      today: 'Aujourd\'hui',
      min: 'Min',
      max: 'Max',
      basedOn: 'Basé sur',
      // Adresse de retrait (réseau TRC20)
      addressTitle: 'Adresse de retrait TRC20',
      addressSubtitle: 'Obligatoire pour retirer vos gains',
      addressVerified: 'Vérifiée',
      addressPending: 'En attente de validation',
      addressRejected: 'Rejetée',
      addressRequired: 'À configurer',
      addressLockedNote: 'Adresse vérifiée et verrouillée définitivement — elle ne peut plus être modifiée. En cas d\'erreur, contactez le support.',
      addressPendingNote: 'Votre adresse est en cours de validation par l\'administrateur. Vous pourrez demander un retrait dès qu\'elle sera vérifiée.',
      addressRejectedNote: 'Adresse rejetée',
      addressPlaceholder: 'Votre adresse TRC20 (commence par T, 34 caractères)',
      addressHint: 'Réseau TRC20 (Tron) uniquement. Vos retraits arriveront directement sur cette adresse — vérifiez bien le réseau avant de la soumettre.',
      addressSubmit: 'Associer mon adresse',
      addressWarning: 'Vérifiez bien votre adresse et le réseau (TRC20) : une fois validée par l\'administrateur, elle ne pourra plus être modifiée. Une adresse ne peut être liée qu\'à un seul compte.',
      addressRequiredNotice: 'Associez d\'abord votre adresse de retrait ci-dessus. Elle doit être validée par l\'administrateur avant toute demande de retrait.',
      addressSaved: 'Adresse enregistrée',
      addressSubmitError: 'Erreur lors de l\'enregistrement',
      howToLabel: 'Comment faire ?',
      addressGuideStep1: '1. Une fois sur Actifs, cliquez sur Ajouter des fonds',
      addressGuideStep2: '2. Sur le menu qui s\'affiche, cliquez sur Deposit Asset',
      addressGuideStep3: '3. Sélectionnez un actif (USDT)',
      addressGuideStep4: '4. Dans la section réseau, sélectionnez TRX Tron (TRC20)',
      addressGuideStep5: '5. Dans l\'onglet qui s\'affiche, copiez votre adresse de dépôt et collez-la ci-dessus',
      addressGuideStep6: '6. Puis validez',
      depGuideStep1: '1. Une fois dans Binance, cliquez sur Actifs, puis sur Envoyer, puis sur Withdraw Asset',
      depGuideStep2: '2. Sélectionnez votre portefeuille USDT',
      depGuideStep3: '3. Sur le formulaire, renseignez l\'adresse (l\'adresse ci-dessous)',
      depGuideStep4: '4. Pour le réseau, sélectionnez Tron TRX (TRC20)',
      depGuideStep5: '5. Renseignez le montant, appuyez sur Retrait, puis confirmez',
      depGuideStep6: '6. Sur le reçu de la transaction, copiez le TXID et renseignez-le dans la zone ci-dessous',
      depGuidePreview: 'Aperçu de l\'écran Binance',
      depGuideHidePreview: 'Masquer l\'aperçu',
      mockFictiveNote: 'Exemple fictif — votre adresse réelle sera différente',
      depositCodeError: 'Erreur lors de la génération du code',
      depMethodTxid: 'Virement TRC20',
      depMethodCode: 'Code admin',
      depAddressLabel: 'Adresse de dépôt',
      depAddressUnavailable: 'Adresse de dépôt non configurée pour le moment. Contactez le support.',
      depNetworkWarning: 'Envoyez uniquement via le réseau TRC20 (Tron). Un envoi sur un autre réseau entraîne une perte définitive des fonds.',
      depTxidLabel: 'TXID de votre transaction',
      depTxidPlaceholder: 'Identifiant de transaction (TXID)',
      depTxidAmountLabel: 'Montant envoyé (USDT)',
      depTxidSubmit: 'Soumettre le virement',
      depHistoryTitle: 'Vos virements soumis',
      txidSubmitSuccess: 'Virement soumis. Il sera vérifié par l\'administrateur avant crédit de votre compte.',
      txidSubmitError: 'Erreur lors de la soumission',
      depositModalTitle: 'Recharger mon compte',
      depositIdleHint: 'Générez un code chiffré lié à votre compte. Transmettez-le à l\'admin qui créditera votre solde.',
      depStepGenerate: 'Générer',
      depStepSend: 'Envoyer',
      depStepReceive: 'Recevoir',
      depositGenerating: 'Génération en cours…',
      depositGenerateBtn: 'Générer mon code de recharge',
      depCodeActive: 'Code actif',
      depTokenLabel: 'Votre code de recharge',
      depScanQr: 'Scanner ce QR code',
      depCopied: 'Code copié !',
      depCopy: 'Copier le code',
      depNeverShare: 'Ne jamais partager publiquement',
      depNewCode: 'Nouveau code',

      // Withdrawal section
      withdrawal: 'Retrait',
      withdrawalStatus: 'Statut de retrait',
      currentMonth: 'Mois en cours',
      cannotWithdrawYet: 'Vous ne pouvez pas encore effectuer de retrait',
      availableFrom: 'Disponible à partir du',
      skippedThisMonth: 'Vous avez choisi de ne pas retirer ce mois',
      skippedUntil: 'Retrait suspendu jusqu\'au',
      extraSuggestions: 'suggestions/jour en bonus',
      pendingRequest: 'Demande de retrait en cours',
      requestedAmount: 'Montant demandé',
      fee: 'Frais',
      netAmount: 'Montant net',
      status: 'Statut',
      statusPending: 'En attente',
      statusApproved: 'Approuvé',
      statusPaid: 'Payé',
      statusRejected: 'Rejeté',
      statusCancelled: 'Annulé',
      cancelRequest: 'Annuler la demande',
      daysUntilDeadline: '{{days}} jour(s) restant(s) pour demander',
      deadlineMissed: 'Délai dépassé pour ce mois',
      withdrawAmount: 'Montant à retirer',
      availableBalance: 'Solde disponible',
      grossAmount: 'Montant brut',
      youWillReceive: 'Vous recevrez',
      processing: 'Traitement...',
      requestWithdrawal: 'Demander le retrait',
      or: 'OU',
      skipForBonus: 'Placez votre argent, multipliez vos gains',
      skipBonusHint: 'Gardez vos fonds investis — obtenez +1 signal gratuit par mois sauté',
      skipCta: 'Activer le bonus',
      currentBonus: 'Bonus actuel',
      suggestionsPerDay: 'suggestions/jour',
      loading: 'Chargement...',
      withdrawalHistory: 'Historique des retraits',
      noWithdrawalHistory: 'Aucun retrait effectué',
      skipWithdrawal: 'Sauter le retrait',
      skipExplanation: 'En choisissant de ne pas retirer pendant plusieurs mois, vous gagnez des suggestions supplémentaires chaque jour.',
      monthsToSkip: 'Nombre de mois à sauter',
      months: 'mois',
      youWillGet: 'Vous obtiendrez',
      extraSuggestionsPerDay: 'suggestions supplémentaires par jour',
      skipWarning: 'Cette action est irréversible. Vous ne pourrez pas demander de retrait pendant la période choisie.',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      invalidAmount: 'Montant invalide',
      withdrawalError: 'Erreur lors de la demande de retrait',
      skipError: 'Erreur lors de la configuration',
      cancelError: 'Erreur lors de l\'annulation',
      tradesPerDayLabel: 'Trades reçus par jour',
      tradesPerDay: 'trades/jour',
    },

    // Profile
    profile: {
      title: 'Profil',
      information: 'Informations',
      referral: 'Parrainage',
      helpContact: 'Aide',
      settings: 'Paramètres',
      userId: 'ID Utilisateur',
      memberSince: 'Membre depuis',
      currentRank: 'Rang actuel',
      status: 'Statut',
      referrals: 'Filleuls',
      bonusEarned: 'Bonus gagnés',
      totalDownline: 'Sous-réseau total (validés)',
      yourReferralCode: 'Votre code de parrainage',
      shareCodeDescription: 'Partagez ce code avec vos amis. Ils doivent l\'entrer lors de leur inscription.',
      howItWorks: 'Comment ça marche ?',
      step1Title: 'Partagez votre code',
      step1Desc: 'Envoyez votre code de parrainage à vos amis',
      step2Title: 'Ils s\'inscrivent',
      step2Desc: 'Vos amis entrent votre code lors de leur inscription',
      step3Title: 'Gagnez des bonus',
      step3Desc: 'Recevez 20% du premier dépôt de chaque filleul',
      rankHierarchy: 'Hiérarchie des rangs',
      bonusSignalsTitle: 'Vos signaux bonus',
      signalsPerDay: 'signaux / jour',
      bonusSignalsInfo: 'Chaque filleul qui active son capital vous donne 1 signal bonus pendant {days} jours (jusqu\'à {cap}). Continuez à parrainer pour les garder !',
      expiresIn: 'expire dans {days} j',
      noBonusSignals: 'Aucun signal bonus actif — parrainez un ami pour en gagner !',
      myReferrals: 'Mes filleuls',
      you: 'Vous',
      moreToReach: 'Plus que {count} filleul(s) pour atteindre le rang {rank}',
      pendingBonus: 'Bonus en attente',
      investing: 'Investissement en cours...',
      investBonusCta: 'Investir {amount} USDT dans mon capital',
      investError: 'Erreur lors de l\'investissement',
      kycTitle: 'Vérification KYC',
      kycSending: 'Envoi en cours…',
      kycSubmitButton: 'Envoyer la demande',
    },

    // Vérification d'identité (KYC)
    kyc: {
      title: 'Vérification d\'identité',
      subtitle1: 'La vérification est requise pour effectuer des retraits.',
      subtitle2: 'Seul l\'administrateur valide manuellement votre document.',
      loading: 'Chargement...',
      statusUnverified: 'Non vérifié',
      statusUnverifiedDesc: 'Soumettez votre pièce d\'identité ci-dessous',
      statusPending: 'En attente de validation',
      document: 'Document',
      submittedOn: 'Soumis le',
      statusVerified: 'Compte vérifié',
      verifiedOn: 'Vérifié le',
      statusRejected: 'Demande rejetée',
      reason: 'Raison',
      resubmitHint: 'Vous pouvez soumettre à nouveau ci-dessous.',
      formTitle: 'Soumettre un document',
      docTypeLabel: 'Type de document',
      cniLabel: 'Carte nationale d\'identité',
      passportLabel: 'Passeport',
      docNumberLabel: 'Numéro du document',
      cniPlaceholder: '15 chiffres — ex: 123456789012345',
      passportPlaceholder: '1 lettre + 8-9 chiffres — ex: A12345678',
      cniCounter: '{n}/15 chiffres',
      passportCounter: '{n}/9-10 caractères (format: X00000000)',
      pendingInfo: 'L\'administrateur examinera votre demande et vous notifiera par email.',
      cniFormatError: 'La CNI doit contenir exactement 15 chiffres (ex: 123456789012345)',
      passportFormatError: 'Le passeport doit commencer par une lettre suivie de 8 à 9 chiffres (ex: A12345678)',
      submitSuccess: 'Demande envoyée. L\'administrateur validera votre compte prochainement.',
      submitError: 'Erreur lors de la soumission',
      loadError: 'Impossible de charger le statut KYC',
    },

    // Support / Messagerie
    support: {
      helpCenter: 'Centre d\'aide',
      replyTime: 'Notre équipe vous répond sous 24h',
      online: 'En ligne',
      loadingConversation: 'Chargement de la conversation...',
      noConversation: 'Aucune conversation',
      askFirstQuestion: 'Posez votre première question à notre équipe support',
      archivedOn: 'Cette conversation sera archivée le',
      seen: 'Vu',
      messageLimit: 'Limite de messages atteinte. Attendez une réponse du support.',
      writePlaceholder: 'Écrivez votre message...',
      loadError: 'Impossible de charger les messages',
      sendError: 'Erreur lors de l\'envoi',
    },

    // Settings
    settings: {
      preferences: 'Préférences',
      language: 'Langue',
      displayCurrency: 'Devise d\'affichage',
      security: 'Sécurité',
      changePassword: 'Modifier le mot de passe',
      lastModified: 'Dernière modification',
      never: 'jamais',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmNewPassword: 'Confirmer le mot de passe',
      enterCurrentPassword: 'Entrez votre mot de passe actuel',
      minChars: 'Min. 6 caractères',
      retypePassword: 'Retapez le nouveau mot de passe',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
      passwordChanged: 'Mot de passe modifié avec succès',
      biometric: 'Authentification biométrique',
      biometricDesc: 'Face ID / Empreinte digitale',
      connectedDevices: 'Appareils connectés',
      activeDevice: '{count} appareil actif',
      activeDevices: '{count} appareils actifs',
      myAccount: 'Mon compte',
      emailAddress: 'Adresse email',
      identifier: 'Identifiant',
      support: 'Support',
      contactSupport: 'Contacter le support',
      telegram: 'Telegram',
      joinCommunity: 'Rejoindre notre communauté',
      helpCenter: 'Centre d\'aide',
      faqGuides: 'FAQ et guides',
      about: 'À propos',
      version: 'Version',
      termsOfService: 'Conditions d\'utilisation',
      privacyPolicy: 'Politique de confidentialité',
      deleteAccount: 'Supprimer le compte',
    },

    // Help & Guide
    guide: {
      title: 'Guide Utilisateur',
      subtitle: 'Apprenez à utiliser la plateforme',

      // Section titles
      gettingStarted: 'Démarrage',
      depositFunds: 'Recharger mon compte',
      tradingGuide: 'Trader',
      withdrawFunds: 'Retirer mes gains',
      referralProgram: 'Parrainer',
      support: 'Assistance',

      // Getting Started
      startTitle: 'Premiers pas',
      startStep1Title: '1. Activer votre compte',
      startStep1: 'Après votre première recharge, allez dans Profil et appuyez sur "Activer mon capital". Cette action débloque l\'accès aux signaux de trading.',
      startStep2Title: '2. Vérifier votre identité (KYC)',
      startStep2: 'Pour pouvoir retirer vos gains, soumettez un document d\'identité dans Profil → KYC. Statuts : Non soumis → En attente → Vérifié.',
      startStep3Title: '3. Recevoir des signaux',
      startStep3: 'Une fois activé, vous recevrez automatiquement des signaux aux heures prévues : vos signaux de base, plus des signaux bonus temporaires selon vos filleuls actifs.',

      // Deposit
      depositTitle: 'Recharger mon compte',
      depositStep1: '1. Allez dans Wallet → "Recharger mon compte" — deux méthodes possibles : virement réel (TRC20) ou code admin',
      depositStep2: '2. Virement réel : dans Binance, Actifs → Envoyer → Withdraw Asset → sélectionnez USDT, collez l\'adresse affichée dans l\'application, choisissez le réseau Tron TRX (TRC20), indiquez le montant puis Retrait',
      depositStep3: '3. Sur le reçu de la transaction Binance, copiez le TXID et renseignez-le avec le montant dans l\'application — ou, avec le code admin, transmettez le code sécurisé affiché (visible 30 secondes) à l\'administrateur',
      depositStep4: '4. L\'administrateur vérifie puis crédite votre compte',
      depositNote: 'Virement réel : réseau TRC20 uniquement — un envoi sur un autre réseau entraîne une perte définitive des fonds. Code admin : chiffré AES-256, aucune donnée sensible ne transite.',

      // Trading
      tradeTitle: 'Accepter un signal',
      tradeStep1: '1. Allez dans Trading → onglet "Suggestions"',
      tradeStep2: '2. Un signal apparaît avec : crypto, montant, gain potentiel, durée',
      tradeStep3: '3. Appuyez sur "Accepter" avant la fin du compte à rebours',
      tradeStep4: '4. Le montant est déduit et la position s\'ouvre',
      tradeStep5: '5. Suivez votre position dans l\'onglet "En Cours"',
      tradeStep6: '6. À la fin, le résultat est crédité/débité automatiquement',
      tradeReject: 'Refuser : appuyez sur "Refuser" → aucun impact sur votre solde.',
      tradeMissed: 'Expiré : si vous ne répondez pas à temps, le signal est perdu.',

      // Withdraw
      withdrawTitle: 'Demander un retrait',
      withdrawStep1: '1. Allez dans Wallet → section "Retrait"',
      withdrawStep2: '2. Vérifiez que votre KYC est validé',
      withdrawStep3: '3. Associez votre adresse de retrait TRC20 (une seule fois) — pour la trouver : dans Binance, Actifs → Ajouter des fonds → Deposit Asset → USDT → réseau TRX Tron (TRC20) → copiez l\'adresse affichée. Elle est vérifiée en temps réel puis validée par l\'administrateur — une fois validée, elle est verrouillée définitivement',
      withdrawStep4: '4. Entrez le montant souhaité',
      withdrawStep5: '5. Confirmez la demande',
      withdrawStep6: '6. L\'administrateur envoie vos fonds directement sur cette adresse (réseau TRC20)',
      withdrawBinanceUnique: 'Important : une adresse de retrait ne peut être liée qu\'à UN seul compte.',
      withdrawFee: 'Frais : {fee}% du montant brut',
      withdrawDelay: '{n} demande(s) de retrait par mois',
      withdrawSkip: 'Option bonus : sautez un mois de retrait pour gagner +1 signal/jour',

      // Referral
      referralTitle: 'Parrainer un ami',
      referralStep1: '1. Allez dans Profil → "Parrainage"',
      referralStep2: '2. Copiez votre code unique (8 caractères)',
      referralStep3: '3. Envoyez-le à vos amis (SMS, WhatsApp...)',
      referralStep4: '4. Votre ami s\'inscrit avec votre code',
      referralStep5: '5. Quand votre filleul active son capital, vous recevez 20% de son investissement en bonus',
      referralRanks: 'Chaque filleul qui active son capital vous donne 1 signal bonus pendant 30 jours (jusqu\'à 10 à la fois). Plus vous parrainez, plus votre niveau de prestige monte.',

      // Ranks (niveaux de prestige, selon le nombre de filleuls)
      ranksTitle: 'Niveaux de prestige',
      rankBronze: 'Bronze : 0 filleul',
      rankSilver: 'Silver : 2+ filleuls',
      rankGold: 'Gold : 5+ filleuls',
      rankPlatinum: 'Platinum : 10+ filleuls',
      rankDiamond: 'Diamond : 20+ filleuls',

      // Schedule
      scheduleTitle: 'Horaires des signaux',
      scheduleInfo: 'Les signaux sont envoyés à heures fixes :',

      // Support
      supportTitle: 'Besoin d\'aide ?',
      supportContact: 'Contactez notre support',
      supportTelegram: 'Rejoignez notre groupe Telegram',

      // Warnings
      warningTitle: 'Avertissement',
      warningRisk: 'Le trading comporte des risques de perte. N\'investissez que ce que vous pouvez perdre.',
      warningAddiction: 'Si vous ressentez un besoin compulsif de trader, consultez un professionnel.',
    },

    // Keep old keys for compatibility
    help: {
      tradesPerDay: 'signaux/jour',
      bronzeBenefit: 'Bronze (0 filleul)',
      silverBenefit: 'Silver (2+ filleuls)',
      goldBenefit: 'Gold (5+ filleuls)',
      platinumBenefit: 'Platinum (10+ filleuls)',
      diamondBenefit: 'Diamond (20+ filleuls)',
      moreReferralsToReach: 'Plus que',
      referralsWord: 'filleul(s)',
      toReachRank: 'pour atteindre le rang',
    },

    // Legal - Terms of Service & Privacy Policy
    legal: {
      termsTitle: 'Conditions Générales d\'Utilisation',
      lastUpdate: 'Dernière mise à jour : Juin 2026',

      article1Title: 'Article 1 — Objet et champ d\'application',
      article1Text: 'Les présentes Conditions Générales d\'Utilisation (ci-après « CGU ») ont pour objet de définir les modalités d\'accès et d\'utilisation de la plateforme CryptoBot Trading (ci-après « la Plateforme »). En accédant à la Plateforme ou en utilisant ses services, l\'Utilisateur reconnaît avoir pris connaissance des présentes CGU et les accepte sans réserve. La Plateforme se réserve le droit de modifier les présentes CGU à tout moment. Les modifications prendront effet dès leur publication sur la Plateforme.',

      article2Title: 'Article 2 — Conditions d\'accès et d\'inscription',
      article2Text: 'L\'utilisation de la Plateforme est réservée aux personnes physiques majeures (âgées d\'au moins 18 ans) jouissant de leur pleine capacité juridique. L\'inscription nécessite la fourniture d\'informations exactes et à jour. L\'Utilisateur s\'engage à maintenir la confidentialité de ses identifiants de connexion et à informer immédiatement la Plateforme en cas d\'utilisation non autorisée de son compte. Toute fausse déclaration pourra entraîner la suspension ou la résiliation du compte sans préavis.',

      article3Title: 'Article 3 — Description des services',
      article3Text: 'La Plateforme propose un service d\'assistance au trading de cryptomonnaies via un algorithme d\'analyse de marché. Ce service comprend : la génération de signaux d\'entrée en position, le suivi des positions ouvertes en temps réel, la gestion de portefeuille, et un programme de parrainage. Les signaux fournis constituent des recommandations et non des conseils en investissement au sens réglementaire du terme.',

      article4Title: 'Article 4 — Avertissement sur les risques',
      article4Text: 'Le trading de cryptomonnaies est une activité à haut risque pouvant entraîner une perte partielle ou totale du capital investi. Les performances passées ne préjugent pas des performances futures. L\'Utilisateur reconnaît être pleinement informé des risques inhérents à cette activité et déclare agir en pleine connaissance de cause. La Plateforme décline toute responsabilité quant aux pertes financières subies par l\'Utilisateur.',

      article5Title: 'Article 5 — Vérification d\'identité (KYC)',
      article5Text: 'Conformément à la réglementation en vigueur relative à la lutte contre le blanchiment d\'argent et le financement du terrorisme, l\'Utilisateur peut être amené à fournir des documents justifiant de son identité. Cette procédure de vérification (KYC - Know Your Customer) est obligatoire pour effectuer des retraits. La Plateforme se réserve le droit de suspendre tout compte dont l\'identité n\'aurait pas été vérifiée ou dont les documents fournis seraient frauduleux.',

      article6Title: 'Article 6 — Dépôts et retraits',
      article6Text: 'Les dépôts sont effectués via un système de code sécurisé validé par l\'administrateur. Les retraits sont soumis à une vérification KYC préalable et à un délai de traitement. Des frais de retrait de 5% s\'appliquent sur le montant brut. La Plateforme se réserve le droit de refuser ou de retarder tout retrait en cas de suspicion de fraude ou d\'activité suspecte.',

      article7Title: 'Article 7 — Propriété intellectuelle',
      article7Text: 'L\'ensemble des éléments constituant la Plateforme (logiciels, algorithmes, bases de données, textes, images, graphiques, logos) sont la propriété exclusive de CryptoBot Trading ou de ses partenaires. Toute reproduction, représentation, modification ou exploitation non autorisée de ces éléments est strictement interdite et constitue une contrefaçon sanctionnée par le Code de la propriété intellectuelle.',

      article8Title: 'Article 8 — Résiliation et suspension',
      article8Text: 'L\'Utilisateur peut résilier son compte à tout moment en adressant une demande au support. La Plateforme se réserve le droit de suspendre ou de résilier immédiatement tout compte en cas de violation des présentes CGU, d\'activité frauduleuse, de manipulation de marché, ou de tout comportement portant atteinte à l\'intégrité de la Plateforme ou de ses utilisateurs. En cas de résiliation, les fonds disponibles seront restitués après déduction des frais applicables.',

      // Privacy Policy
      privacyTitle: 'Politique de Confidentialité',
      privacyContact: 'Contact DPO : privacy@cryptobot.com',

      privacy1Title: '1. Données collectées',
      privacy1Text: 'Dans le cadre de l\'utilisation de nos services, nous collectons les données suivantes : données d\'identification (nom d\'utilisateur, adresse email), données de connexion (adresse IP, logs de connexion), données de transaction (historique des trades, mouvements de fonds), documents d\'identité (dans le cadre du KYC). Ces données sont collectées avec le consentement explicite de l\'Utilisateur lors de son inscription.',

      privacy2Title: '2. Finalités du traitement',
      privacy2Text: 'Les données collectées sont utilisées pour : la gestion de votre compte et l\'exécution des services, le respect de nos obligations légales et réglementaires (notamment KYC/AML), l\'amélioration de nos services et de l\'expérience utilisateur, la prévention des fraudes et la sécurisation de la Plateforme, l\'envoi de communications relatives à votre compte (notifications, alertes).',

      privacy3Title: '3. Conservation des données',
      privacy3Text: 'Vos données personnelles sont conservées pendant toute la durée de votre inscription, puis archivées conformément aux obligations légales de conservation (5 ans pour les données de transaction, 10 ans pour les documents KYC). Au-delà de ces délais, vos données sont définitivement supprimées ou anonymisées.',

      privacy4Title: '4. Sécurité des données',
      privacy4Text: 'Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données : chiffrement SSL/TLS pour les communications, chiffrement AES-256 pour les données sensibles, hachage bcrypt pour les mots de passe, accès restreint aux données selon le principe du moindre privilège, audits de sécurité réguliers.',

      privacy5Title: '5. Vos droits',
      privacy5Text: 'Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants : droit d\'accès à vos données, droit de rectification des données inexactes, droit à l\'effacement (« droit à l\'oubli »), droit à la limitation du traitement, droit à la portabilité de vos données, droit d\'opposition au traitement. Pour exercer ces droits, contactez notre Délégué à la Protection des Données à l\'adresse indiquée ci-dessous.',
    },

    // Admin
    admin: {
      title: 'Administration',
      dashboard: 'Tableau de bord',
      users: 'Utilisateurs',
      configs: 'Configuration',
      withdrawals: 'Retraits',
      kyc: 'KYC',
      schedule: 'Planning',
      deposits: 'Dépôts',
      // Schedule
      monthlySchedule: 'Planning Mensuel des Trades',
      tradesForDay: 'Trades du jour',
      month: 'Mois',
      totalSlots: 'Slots total',
      distributed: 'Distribués',
      manuallyEdited: 'Édités manuellement',
      regenerateFuture: 'Régénérer les slots futurs',
      regenerateConfirm: 'Régénérer les slots futurs non distribués et non édités manuellement?',
      regenerated: 'slots régénérés',
      protected: 'protégés',
      slot: 'Slot',
      modify: 'Modifier',
      save: 'Sauvegarder',
      cancel: 'Annuler',
      pastTime: 'Heure passée',
      modified: 'Modifié',
      potentialGain: 'Gain potentiel',
      actualGain: 'Gain réel',
      duration: 'Durée',
      confidence: 'Confiance',
      buy: 'ACHAT',
      sell: 'VENTE',
      // Slot stats
      usersEligible: 'Utilisateurs éligibles',
      usersValidated: 'Ont validé',
      usersRejected: 'Ont refusé',
      usersMissed: 'Ont loupé',
      noSlotData: 'Aucune donnée',
      // Users
      searchUser: 'Rechercher un utilisateur...',
      balance: 'Solde',
      rank: 'Rang',
      status: 'Statut',
      actions: 'Actions',
      credit: 'Créditer',
      debit: 'Débiter',
      block: 'Bloquer',
      unblock: 'Débloquer',
      delete: 'Supprimer',
      viewTransactions: 'Voir transactions',
      amount: 'Montant',
      reason: 'Motif',
      confirmTransaction: 'Confirmer la transaction',
      confirmDelete: 'Confirmer la suppression',
      // KYC
      kycPending: 'KYC en attente',
      kycVerified: 'KYC vérifiés',
      kycRejected: 'KYC rejetés',
      verify: 'Vérifier',
      reject: 'Rejeter',
      rejectReason: 'Motif de rejet',
      documentType: 'Type de document',
      documentNumber: 'Numéro de document',
      // Withdrawals
      pendingWithdrawals: 'Retraits en attente',
      approvedWithdrawals: 'Retraits approuvés',
      paidWithdrawals: 'Retraits payés',
      totalPending: 'Total en attente',
      approve: 'Approuver',
      markPaid: 'Marquer payé',
      paymentRef: 'Référence paiement',
      paymentMethod: 'Méthode de paiement',
      system: 'Système',
      today: 'Aujourd\'hui',
      regenerating: 'Régénération...',
      regenerateFutureSlots: 'Régénérer les slots futurs',
      protectedSlotsWarning: 'Les slots déjà distribués ou modifiés manuellement sont protégés.',
      noSchedule: 'Aucun planning disponible',
    },

    // Time
    time: {
      seconds: 's',
      minutes: 'm',
      hours: 'h',
      days: 'j',
      ago: 'il y a',
      remaining: 'restant',
    },
  },

  en: {
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      copy: 'Copy',
      copied: 'Copied!',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      yes: 'Yes',
      no: 'No',
      active: 'Active',
      inactive: 'Inactive',
      verified: 'Verified',
      allRightsReserved: 'All rights reserved',
      seeAll: 'See all',
      portfolioValue: 'Portfolio Value',
    },

    // Navigation
    nav: {
      home: 'Home',
      markets: 'Markets',
      trading: 'Trading',
      wallet: 'Wallet',
      profile: 'Profile',
      messages: 'Messages',
    },

    // Auth
    auth: {
      login: 'Log in',
      loginTitle: 'Sign in to your account',
      register: 'Create account',
      registerTitle: 'Create your account',
      logout: 'Log out',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      username: 'Username',
      referralCode: 'Referral code',
      optional: 'optional',
      referralHint: 'If you have a referral code, enter it to earn bonuses!',
      forgotPassword: 'Forgot password?',
      noAccount: 'Don\'t have an account?',
      hasAccount: 'Already have an account?',
      createAccount: 'Create account',
      loginSuccess: 'Login successful',
      registerSuccess: 'Registration successful',
      invalidCredentials: 'Incorrect email or password',
      loggingIn: 'Logging in...',
      creating: 'Creating...',
      signupBonus: '',
      verifyTitle: 'Verify your email',
      verifyAdminTitle: 'Administrator login code',
      verifySentTo: 'A 6-digit code was sent to',
      verifyCodeLabel: 'Verification code',
      verifyExpiresIn: 'Expires in',
      verifyExpired: 'This code has expired — request a new one',
      verifySubmit: 'Verify',
      verifyChecking: 'Verifying...',
      verifyResend: 'Resend code',
      verifyResendWait: 'Resend in',
      verifyResendSuccess: 'New code sent',
      verifyBackToLogin: 'Back to login',
      forgotPasswordTitle: 'Forgot password',
      forgotPasswordHint: 'Enter your email, we\'ll send you a code to reset your password.',
      forgotPasswordSubmit: 'Send code',
      forgotPasswordReset: 'Reset password',
      passwordResetSuccess: 'Password reset — log in with your new password',
      passwordMismatch: 'Passwords do not match',
      pwdRuleLength: 'At least 8 characters',
      pwdRuleUpper: 'One uppercase letter (A-Z)',
      pwdRuleLower: 'One lowercase letter (a-z)',
      pwdRuleNumber: 'One digit (0-9)',
      pwdRuleSpecial: 'One special character (!@#$…)',
      strengthWeak: 'Weak',
      strengthMedium: 'Medium',
      strengthStrong: 'Strong',
      usernameMinError: 'At least 3 characters',
      emailInvalid: 'Invalid email address',
      passwordsMatchOk: 'Passwords match ✓',
      referralValid: 'Valid referral code',
      referralCounter: '{n}/8 characters',
      referralRequired: 'A referral code is required to create an account',
      referralInvalid: 'Invalid referral code',
      checkUsername: 'Username (min 3 chars)',
      checkEmail: 'Invalid email',
      checkPassword: 'Incomplete password',
      checkPasswordsMatch: 'Passwords differ',
      passwordTooShort: 'Password must be at least 8 characters',
      usernameTooShort: 'Username must be at least 3 characters',
    },

    // Dashboard
    dashboard: {
      totalBalance: 'Total Balance',
      variation: 'Change',
      quickStats: 'Quick Stats',
      welcomeReferredTitle: 'Welcome to CryptoBot!',
      welcomeReferredBody: 'You were referred by {name}. Deposit funds to start trading and earning.',
      welcomeReferredContactLine: 'Reach {name} at {email}',
      welcomeReferredContactLineNoEmail: 'Reach {name} via Messages',
      welcomeReferredRecharge: 'Deposit funds',
      welcomeReferredContact: 'Contact support',
      nudgeReferrerTitle: 'Follow up with your referral',
      nudgeReferrerBody: '{name} hasn\'t deposited yet — invite them to invest so you receive your referral bonus!',
      wonTrades: 'Won Trades',
      pending: 'Pending',
      successRate: 'Success Rate',
      topCryptos: 'Top Cryptos',
      dailyChart: 'Chart of the day',
      tradingBot: 'Trading Bot',
      botActive: 'Active',
      botAnalyzing: 'Analyzing...',
      scanningMarkets: 'Scanning crypto markets',
      botMessage: 'The bot analyzes trends and will send you optimal trading opportunities.',
      botSignalValidated: 'Signal validated',
      botSignalRejected: 'Skipped',
      botMarketsAnalyzed: 'markets analyzed',
      botScanning: 'Analyzing',
      capitalToInvest: 'Capital to invest',
      invest: 'Invest',
      viewSuggestions: 'View Suggestions',
      goToTrading: 'Go to Trading',
      goToWallet: 'Go to Wallet',
    },

    // Markets
    markets: {
      title: 'Markets',
      search: 'Search crypto...',
      price: 'Price',
      change24h: '24h Change',
      volume: '24h Volume',
      marketCap: 'Market Cap',
      allCryptos: 'All cryptos',
      pricesAutoUpdate: 'Prices are automatically updated every 30 seconds',
      tools: 'Tools',
      toggleTools: 'Show / hide drawing tools',
    },

    // Trading
    trading: {
      suggestions: 'Suggestions',
      inProgress: 'In Progress',
      completed: 'Completed',
      missed: 'MISSED',
      accept: 'Accept',
      reject: 'Reject',
      potentialGain: 'Potential gain',
      duration: 'Duration',
      amount: 'Amount',
      startsIn: 'Starts in',
      expired: 'Expired',
      noSuggestions: 'No suggestions at the moment',
      noActiveTrades: 'No active position',
      noActivePosDesc: 'Accept a suggestion to open a trading position.',
      noCompletedTrades: 'No completed trades',
      tradeAccepted: 'Trade accepted',
      tradeRejected: 'Trade rejected',
      missedTrade: 'Missed opportunity',
      youCouldHaveWon: 'You could have won',
      tradeSuccess: 'Trade successful',
      youWon: 'You won',
      buy: 'BUY',
      sell: 'SELL',
      validated: 'VALIDATED',
      pending: 'PENDING',
      invested: 'Invested',
      gain: 'Gain',
      gainsPaid: 'Gains paid',
      lossPaid: 'Result settled',
      closed: 'CLOSED',
      live: 'LIVE',
      tradeEnded: 'Trade ended',
      timeRemaining: 'Time remaining',
      progression: 'Progress',
      investedAmount: 'Amount invested',
      entryPrice: 'Entry price',
      currentPrice: 'Current price',
      currentGain: 'Current gain',
      tradeExecuting: 'Trade executing',
      gainsAutomatic: 'Gains will be paid automatically at closing',
      waitingNext: 'Waiting for the next opportunity...',
      suggestionsPerDay: 'Signals/day',
      averageGain: 'Avg. gain',
      howItWorks: 'How does it work?',
      step1Title: 'Suggestion',
      step1Desc: 'The bot proposes a trade',
      step2Title: 'Validation',
      step2Desc: 'You accept or reject',
      step3Title: 'Result',
      step3Desc: 'Gains paid at closing',
      acceptError: 'Error accepting trade',
      rejectError: 'Error rejecting trade',
      signalsToday: 'Signals today',
    },

    // Wallet
    wallet: {
      title: 'Wallet',
      totalBalance: 'Total Balance',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      myAssets: 'My Assets',
      performance: 'Performance',
      projections: 'Projections',
      history: 'History',
      noTransactions: 'No transactions',
      noTransactionsDesc: 'Your trade history will appear here once you start trading.',
      projectionDisclaimer: 'Estimates based on current conditions. Actual results may vary.',
      profit: 'Profit',
      trades: 'Trades',
      successRate: 'Success rate',
      bestTrade: 'Best trade',
      overview: 'Overview',
      usDollar: 'Tether USD',
      cryptoHint: 'Your purchased cryptos will appear here',
      variation: 'Change',
      chartHint: 'Touch the chart to see details',
      growthForecast: 'Growth Forecast',
      noWithdrawalEstimate: 'Estimate if you make no withdrawals',
      month1: '1 Month',
      month3: '3 Months',
      month6: '6 Months',
      currentBalance: 'Current balance',
      target: 'Target',
      estimatedGain: 'Estimated potential gain',
      balance: 'Balance',
      securedFunds: 'Secured funds',
      smartTrading: 'Smart trading',
      now: 'Now',
      today: 'Today',
      min: 'Min',
      max: 'Max',
      basedOn: 'Based on',
      // Withdrawal address (TRC20 network)
      addressTitle: 'TRC20 withdrawal address',
      addressSubtitle: 'Required to withdraw your earnings',
      addressVerified: 'Verified',
      addressPending: 'Awaiting validation',
      addressRejected: 'Rejected',
      addressRequired: 'To set up',
      addressLockedNote: 'Address verified and permanently locked — it can no longer be changed. Contact support if there is an error.',
      addressPendingNote: 'Your address is being validated by the administrator. You will be able to request a withdrawal once verified.',
      addressRejectedNote: 'Address rejected',
      addressPlaceholder: 'Your TRC20 address (starts with T, 34 characters)',
      addressHint: 'TRC20 (Tron) network only. Your withdrawals will arrive directly at this address — double-check the network before submitting.',
      addressSubmit: 'Link my address',
      addressWarning: 'Double-check your address and network (TRC20): once validated by the administrator, it can no longer be changed. An address can only be linked to one account.',
      addressRequiredNotice: 'First link your withdrawal address above. It must be validated by the administrator before any withdrawal request.',
      addressSaved: 'Address saved',
      addressSubmitError: 'Error while saving',
      howToLabel: 'How to do this?',
      addressGuideStep1: '1. Once on Assets, tap Add Funds',
      addressGuideStep2: '2. In the menu that appears, tap Deposit Asset',
      addressGuideStep3: '3. Select an asset (USDT)',
      addressGuideStep4: '4. In the network section, select TRX Tron (TRC20)',
      addressGuideStep5: '5. On the screen that appears, copy your deposit address and paste it above',
      addressGuideStep6: '6. Then confirm',
      depGuideStep1: '1. Once in Binance, tap Assets, then Send, then Withdraw Asset',
      depGuideStep2: '2. Select your USDT wallet',
      depGuideStep3: '3. On the form, enter the address (the address below)',
      depGuideStep4: '4. For the network, select Tron TRX (TRC20)',
      depGuideStep5: '5. Enter the amount, tap Withdraw, then confirm',
      depGuideStep6: '6. On the transaction receipt, copy the TXID and enter it in the field below',
      depGuidePreview: 'Preview the Binance screen',
      depGuideHidePreview: 'Hide preview',
      mockFictiveNote: 'Fictional example — your real address will be different',
      depositCodeError: 'Error while generating the code',
      depMethodTxid: 'TRC20 transfer',
      depMethodCode: 'Admin code',
      depAddressLabel: 'Deposit address',
      depAddressUnavailable: 'Deposit address not configured yet. Contact support.',
      depNetworkWarning: 'Only send via the TRC20 (Tron) network. Sending on another network results in permanent loss of funds.',
      depTxidLabel: 'Your transaction TXID',
      depTxidPlaceholder: 'Transaction ID (TXID)',
      depTxidAmountLabel: 'Amount sent (USDT)',
      depTxidSubmit: 'Submit transfer',
      depHistoryTitle: 'Your submitted transfers',
      txidSubmitSuccess: 'Transfer submitted. It will be verified by the administrator before your account is credited.',
      txidSubmitError: 'Error while submitting',
      depositModalTitle: 'Deposit to my account',
      depositIdleHint: 'Generate an encrypted code linked to your account. Send it to the admin who will credit your balance.',
      depStepGenerate: 'Generate',
      depStepSend: 'Send',
      depStepReceive: 'Receive',
      depositGenerating: 'Generating…',
      depositGenerateBtn: 'Generate my deposit code',
      depCodeActive: 'Code active',
      depTokenLabel: 'Your deposit code',
      depScanQr: 'Scan this QR code',
      depCopied: 'Code copied!',
      depCopy: 'Copy the code',
      depNeverShare: 'Never share publicly',
      depNewCode: 'New code',
      // Withdrawal section
      withdrawal: 'Withdrawal',
      withdrawalStatus: 'Withdrawal Status',
      currentMonth: 'Current Month',
      cannotWithdrawYet: 'You cannot withdraw yet',
      availableFrom: 'Available from',
      skippedThisMonth: 'You chose to skip withdrawals this month',
      skippedUntil: 'Withdrawals suspended until',
      extraSuggestions: 'bonus suggestions/day',
      pendingRequest: 'Withdrawal request pending',
      requestedAmount: 'Requested amount',
      fee: 'Fee',
      netAmount: 'Net amount',
      status: 'Status',
      statusPending: 'Pending',
      statusApproved: 'Approved',
      statusPaid: 'Paid',
      statusRejected: 'Rejected',
      statusCancelled: 'Cancelled',
      cancelRequest: 'Cancel request',
      daysUntilDeadline: '{{days}} day(s) left to request',
      deadlineMissed: 'Deadline passed for this month',
      withdrawAmount: 'Amount to withdraw',
      availableBalance: 'Available balance',
      grossAmount: 'Gross amount',
      youWillReceive: 'You will receive',
      processing: 'Processing...',
      requestWithdrawal: 'Request Withdrawal',
      or: 'OR',
      skipForBonus: 'Put your money to work, multiply your gains',
      skipBonusHint: 'Keep your funds invested — earn +1 free signal per skipped month',
      skipCta: 'Activate bonus',
      currentBonus: 'Current bonus',
      suggestionsPerDay: 'suggestions/day',
      loading: 'Loading...',
      withdrawalHistory: 'Withdrawal History',
      noWithdrawalHistory: 'No withdrawals yet',
      skipWithdrawal: 'Skip Withdrawal',
      skipExplanation: 'By choosing not to withdraw for several months, you earn extra suggestions every day.',
      monthsToSkip: 'Months to skip',
      months: 'months',
      youWillGet: 'You will get',
      extraSuggestionsPerDay: 'extra suggestions per day',
      skipWarning: 'This action is irreversible. You will not be able to request withdrawals during the chosen period.',
      cancel: 'Cancel',
      confirm: 'Confirm',
      invalidAmount: 'Invalid amount',
      withdrawalError: 'Error requesting withdrawal',
      skipError: 'Error configuring skip',
      cancelError: 'Error cancelling request',
      tradesPerDayLabel: 'Trades received per day',
      tradesPerDay: 'trades/day',
    },

    // Profile
    profile: {
      title: 'Profile',
      information: 'Information',
      referral: 'Referral',
      helpContact: 'Help',
      settings: 'Settings',
      userId: 'User ID',
      memberSince: 'Member since',
      currentRank: 'Current rank',
      status: 'Status',
      referrals: 'Referrals',
      bonusEarned: 'Bonus earned',
      totalDownline: 'Total downline (validated)',
      yourReferralCode: 'Your referral code',
      shareCodeDescription: 'Share this code with your friends. They must enter it during registration.',
      howItWorks: 'How does it work?',
      step1Title: 'Share your code',
      step1Desc: 'Send your referral code to your friends',
      step2Title: 'They sign up',
      step2Desc: 'Your friends enter your code during registration',
      step3Title: 'Earn bonuses',
      step3Desc: 'Receive 20% of each referral\'s first deposit',
      rankHierarchy: 'Rank hierarchy',
      bonusSignalsTitle: 'Your bonus signals',
      signalsPerDay: 'signals / day',
      bonusSignalsInfo: 'Each referral who activates their capital gives you 1 bonus signal for {days} days (up to {cap}). Keep referring to keep them!',
      expiresIn: 'expires in {days}d',
      noBonusSignals: 'No active bonus signals — refer a friend to earn some!',
      myReferrals: 'My referrals',
      you: 'You',
      moreToReach: '{count} more referral(s) to reach {rank} rank',
      pendingBonus: 'Pending bonus',
      investing: 'Investing...',
      investBonusCta: 'Invest {amount} USDT into my capital',
      investError: 'Error while investing',
      kycTitle: 'KYC Verification',
      kycSending: 'Sending…',
      kycSubmitButton: 'Submit request',
    },

    // Identity verification (KYC)
    kyc: {
      title: 'Identity verification',
      subtitle1: 'Verification is required to make withdrawals.',
      subtitle2: 'Only the administrator manually validates your document.',
      loading: 'Loading...',
      statusUnverified: 'Not verified',
      statusUnverifiedDesc: 'Submit your identity document below',
      statusPending: 'Awaiting validation',
      document: 'Document',
      submittedOn: 'Submitted on',
      statusVerified: 'Account verified',
      verifiedOn: 'Verified on',
      statusRejected: 'Request rejected',
      reason: 'Reason',
      resubmitHint: 'You can submit again below.',
      formTitle: 'Submit a document',
      docTypeLabel: 'Document type',
      cniLabel: 'National ID card',
      passportLabel: 'Passport',
      docNumberLabel: 'Document number',
      cniPlaceholder: '15 digits — e.g. 123456789012345',
      passportPlaceholder: '1 letter + 8-9 digits — e.g. A12345678',
      cniCounter: '{n}/15 digits',
      passportCounter: '{n}/9-10 characters (format: X00000000)',
      pendingInfo: 'The administrator will review your request and notify you by email.',
      cniFormatError: 'The ID card number must contain exactly 15 digits (e.g. 123456789012345)',
      passportFormatError: 'The passport must start with a letter followed by 8 to 9 digits (e.g. A12345678)',
      submitSuccess: 'Request sent. The administrator will validate your account shortly.',
      submitError: 'Error while submitting',
      loadError: 'Unable to load KYC status',
    },

    // Support / Messaging
    support: {
      helpCenter: 'Help Center',
      replyTime: 'Our team replies within 24h',
      online: 'Online',
      loadingConversation: 'Loading conversation...',
      noConversation: 'No conversation yet',
      askFirstQuestion: 'Ask your first question to our support team',
      archivedOn: 'This conversation will be archived on',
      seen: 'Seen',
      messageLimit: 'Message limit reached. Please wait for a reply from support.',
      writePlaceholder: 'Write your message...',
      loadError: 'Unable to load messages',
      sendError: 'Error while sending',
    },

    // Settings
    settings: {
      preferences: 'Preferences',
      language: 'Language',
      displayCurrency: 'Display currency',
      security: 'Security',
      changePassword: 'Change password',
      lastModified: 'Last modified',
      never: 'never',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm password',
      enterCurrentPassword: 'Enter your current password',
      minChars: 'Min. 6 characters',
      retypePassword: 'Retype new password',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      passwordChanged: 'Password changed successfully',
      biometric: 'Biometric authentication',
      biometricDesc: 'Face ID / Fingerprint',
      connectedDevices: 'Connected devices',
      activeDevice: '{count} active device',
      activeDevices: '{count} active devices',
      myAccount: 'My Account',
      emailAddress: 'Email address',
      identifier: 'Identifier',
      support: 'Support',
      contactSupport: 'Contact support',
      telegram: 'Telegram',
      joinCommunity: 'Join our community',
      helpCenter: 'Help center',
      faqGuides: 'FAQ and guides',
      about: 'About',
      version: 'Version',
      termsOfService: 'Terms of service',
      privacyPolicy: 'Privacy policy',
      deleteAccount: 'Delete account',
    },

    // Help & Guide
    guide: {
      title: 'User Guide',
      subtitle: 'Learn how to use the platform',

      // Section titles
      gettingStarted: 'Getting Started',
      depositFunds: 'Deposit Funds',
      tradingGuide: 'Trading',
      withdrawFunds: 'Withdraw Funds',
      referralProgram: 'Referral',
      support: 'Support',

      // Getting Started
      startTitle: 'First Steps',
      startStep1Title: '1. Activate your account',
      startStep1: 'After your first deposit, go to Profile and tap "Activate my capital". This unlocks access to trading signals.',
      startStep2Title: '2. Verify your identity (KYC)',
      startStep2: 'To withdraw your earnings, submit an ID document in Profile → KYC. Status: Not submitted → Pending → Verified.',
      startStep3Title: '3. Receive signals',
      startStep3: 'Once activated, you will automatically receive signals at scheduled times: your base signals, plus temporary bonus signals based on your active referrals.',

      // Deposit
      depositTitle: 'Deposit Funds',
      depositStep1: '1. Go to Wallet → "Deposit Funds" — two methods available: real transfer (TRC20) or admin code',
      depositStep2: '2. Real transfer: in Binance, tap Assets → Send → Withdraw Asset → select USDT, paste the address shown in the app, choose the Tron TRX (TRC20) network, enter the amount then Withdraw',
      depositStep3: '3. On the Binance transaction receipt, copy the TXID and enter it with the amount in the app — or, with the admin code, send the secure code shown (visible 30 seconds) to the administrator',
      depositStep4: '4. The administrator verifies then credits your account',
      depositNote: 'Real transfer: TRC20 network only — sending on another network results in permanent loss of funds. Admin code: AES-256 encrypted, no sensitive data transmitted.',

      // Trading
      tradeTitle: 'Accept a Signal',
      tradeStep1: '1. Go to Trading → "Suggestions" tab',
      tradeStep2: '2. A signal appears with: crypto, amount, potential gain, duration',
      tradeStep3: '3. Tap "Accept" before the countdown ends',
      tradeStep4: '4. The amount is deducted and the position opens',
      tradeStep5: '5. Track your position in the "In Progress" tab',
      tradeStep6: '6. At the end, the result is automatically credited/debited',
      tradeReject: 'Reject: tap "Reject" → no impact on your balance.',
      tradeMissed: 'Expired: if you don\'t respond in time, the signal is lost.',

      // Withdraw
      withdrawTitle: 'Request a Withdrawal',
      withdrawStep1: '1. Go to Wallet → "Withdrawal" section',
      withdrawStep2: '2. Check that your KYC is verified',
      withdrawStep3: '3. Link your TRC20 withdrawal address (once only) — to find it: in Binance, tap Assets → Add Funds → Deposit Asset → USDT → TRX Tron (TRC20) network → copy the address shown. It is checked in real time then validated by the administrator — once validated, it is permanently locked',
      withdrawStep4: '4. Enter the desired amount',
      withdrawStep5: '5. Confirm the request',
      withdrawStep6: '6. The administrator sends your funds directly to this address (TRC20 network)',
      withdrawBinanceUnique: 'Important: a withdrawal address can only be linked to ONE account.',
      withdrawFee: 'Fee: {fee}% of gross amount',
      withdrawDelay: '{n} withdrawal request(s) per month',
      withdrawSkip: 'Bonus option: skip a withdrawal month to get +1 signal/day',

      // Referral
      referralTitle: 'Refer a Friend',
      referralStep1: '1. Go to Profile → "Referral"',
      referralStep2: '2. Copy your unique code (8 characters)',
      referralStep3: '3. Send it to your friends (SMS, WhatsApp...)',
      referralStep4: '4. Your friend signs up with your code',
      referralStep5: '5. When your referral activates their capital, you receive a 20% bonus on their investment',
      referralRanks: 'Each referral who activates their capital gives you 1 bonus signal for 30 days (up to 10 at once). More referrals = higher prestige level.',

      // Ranks (prestige levels, based on number of referrals)
      ranksTitle: 'Prestige Levels',
      rankBronze: 'Bronze: 0 referrals',
      rankSilver: 'Silver: 2+ referrals',
      rankGold: 'Gold: 5+ referrals',
      rankPlatinum: 'Platinum: 10+ referrals',
      rankDiamond: 'Diamond: 20+ referrals',

      // Schedule
      scheduleTitle: 'Signal Schedule',
      scheduleInfo: 'Signals are sent at fixed times:',

      // Support
      supportTitle: 'Need Help?',
      supportContact: 'Contact our support',
      supportTelegram: 'Join our Telegram group',

      // Warnings
      warningTitle: 'Warning',
      warningRisk: 'Trading involves risk of loss. Only invest what you can afford to lose.',
      warningAddiction: 'If you feel a compulsive need to trade, consult a professional.',
    },

    // Keep old keys for compatibility
    help: {
      tradesPerDay: 'signals/day',
      bronzeBenefit: 'Bronze (0 referrals)',
      silverBenefit: 'Silver (2+ referrals)',
      goldBenefit: 'Gold (5+ referrals)',
      platinumBenefit: 'Platinum (10+ referrals)',
      diamondBenefit: 'Diamond (20+ referrals)',
      moreReferralsToReach: 'Only',
      referralsWord: 'referral(s)',
      toReachRank: 'more to reach',
    },

    // Legal - Terms of Service & Privacy Policy
    legal: {
      termsTitle: 'Terms of Service',
      lastUpdate: 'Last updated: June 2026',

      article1Title: 'Article 1 — Purpose and Scope',
      article1Text: 'These Terms of Service (hereinafter "Terms") define the conditions for accessing and using the CryptoBot Trading platform (hereinafter "the Platform"). By accessing the Platform or using its services, the User acknowledges having read these Terms and accepts them without reservation. The Platform reserves the right to modify these Terms at any time. Modifications will take effect upon publication on the Platform.',

      article2Title: 'Article 2 — Access and Registration Conditions',
      article2Text: 'Use of the Platform is reserved for natural persons who are of legal age (at least 18 years old) and have full legal capacity. Registration requires providing accurate and up-to-date information. The User agrees to maintain the confidentiality of their login credentials and to immediately inform the Platform of any unauthorized use of their account. Any false declaration may result in suspension or termination of the account without notice.',

      article3Title: 'Article 3 — Description of Services',
      article3Text: 'The Platform offers a cryptocurrency trading assistance service via a market analysis algorithm. This service includes: generation of position entry signals, real-time tracking of open positions, portfolio management, and a referral program. The signals provided constitute recommendations and not investment advice within the regulatory meaning of the term.',

      article4Title: 'Article 4 — Risk Warning',
      article4Text: 'Cryptocurrency trading is a high-risk activity that may result in partial or total loss of invested capital. Past performance does not guarantee future results. The User acknowledges being fully informed of the risks inherent to this activity and declares to act with full knowledge of the facts. The Platform disclaims all liability for financial losses incurred by the User.',

      article5Title: 'Article 5 — Identity Verification (KYC)',
      article5Text: 'In accordance with current regulations on anti-money laundering and counter-terrorist financing, the User may be required to provide documents proving their identity. This verification procedure (KYC - Know Your Customer) is mandatory for making withdrawals. The Platform reserves the right to suspend any account whose identity has not been verified or whose documents provided are fraudulent.',

      article6Title: 'Article 6 — Deposits and Withdrawals',
      article6Text: 'Deposits are made via a secure code system validated by the administrator. Withdrawals are subject to prior KYC verification and a processing period. A withdrawal fee of 5% applies to the gross amount. The Platform reserves the right to refuse or delay any withdrawal in case of suspected fraud or suspicious activity.',

      article7Title: 'Article 7 — Intellectual Property',
      article7Text: 'All elements constituting the Platform (software, algorithms, databases, texts, images, graphics, logos) are the exclusive property of CryptoBot Trading or its partners. Any unauthorized reproduction, representation, modification, or exploitation of these elements is strictly prohibited and constitutes infringement punishable under Intellectual Property Law.',

      article8Title: 'Article 8 — Termination and Suspension',
      article8Text: 'The User may terminate their account at any time by sending a request to support. The Platform reserves the right to immediately suspend or terminate any account in case of violation of these Terms, fraudulent activity, market manipulation, or any behavior that undermines the integrity of the Platform or its users. In case of termination, available funds will be returned after deduction of applicable fees.',

      // Privacy Policy
      privacyTitle: 'Privacy Policy',
      privacyContact: 'DPO Contact: privacy@cryptobot.com',

      privacy1Title: '1. Data Collected',
      privacy1Text: 'In the course of using our services, we collect the following data: identification data (username, email address), connection data (IP address, connection logs), transaction data (trade history, fund movements), identity documents (as part of KYC). This data is collected with the explicit consent of the User upon registration.',

      privacy2Title: '2. Processing Purposes',
      privacy2Text: 'The data collected is used for: managing your account and executing services, compliance with our legal and regulatory obligations (including KYC/AML), improving our services and user experience, fraud prevention and Platform security, sending communications related to your account (notifications, alerts).',

      privacy3Title: '3. Data Retention',
      privacy3Text: 'Your personal data is retained for the duration of your registration, then archived in accordance with legal retention obligations (5 years for transaction data, 10 years for KYC documents). Beyond these periods, your data is permanently deleted or anonymized.',

      privacy4Title: '4. Data Security',
      privacy4Text: 'We implement appropriate technical and organizational measures to protect your data: SSL/TLS encryption for communications, AES-256 encryption for sensitive data, bcrypt hashing for passwords, restricted access to data according to the principle of least privilege, regular security audits.',

      privacy5Title: '5. Your Rights',
      privacy5Text: 'In accordance with the General Data Protection Regulation (GDPR), you have the following rights: right of access to your data, right to rectify inaccurate data, right to erasure ("right to be forgotten"), right to restriction of processing, right to data portability, right to object to processing. To exercise these rights, contact our Data Protection Officer at the address below.',
    },

    // Admin
    admin: {
      title: 'Administration',
      dashboard: 'Dashboard',
      users: 'Users',
      configs: 'Configuration',
      withdrawals: 'Withdrawals',
      kyc: 'KYC',
      schedule: 'Schedule',
      deposits: 'Deposits',
      // Schedule
      monthlySchedule: 'Monthly Trade Schedule',
      tradesForDay: 'Trades for day',
      month: 'Month',
      totalSlots: 'Total slots',
      distributed: 'Distributed',
      manuallyEdited: 'Manually edited',
      regenerateFuture: 'Regenerate future slots',
      regenerateConfirm: 'Regenerate future non-distributed and non-edited slots?',
      regenerated: 'slots regenerated',
      protected: 'protected',
      slot: 'Slot',
      modify: 'Modify',
      save: 'Save',
      cancel: 'Cancel',
      pastTime: 'Past time',
      modified: 'Modified',
      potentialGain: 'Potential gain',
      actualGain: 'Actual gain',
      duration: 'Duration',
      confidence: 'Confidence',
      buy: 'BUY',
      sell: 'SELL',
      // Slot stats
      usersEligible: 'Eligible users',
      usersValidated: 'Validated',
      usersRejected: 'Rejected',
      usersMissed: 'Missed',
      noSlotData: 'No data',
      // Users
      searchUser: 'Search user...',
      balance: 'Balance',
      rank: 'Rank',
      status: 'Status',
      actions: 'Actions',
      credit: 'Credit',
      debit: 'Debit',
      block: 'Block',
      unblock: 'Unblock',
      delete: 'Delete',
      viewTransactions: 'View transactions',
      amount: 'Amount',
      reason: 'Reason',
      confirmTransaction: 'Confirm transaction',
      confirmDelete: 'Confirm deletion',
      // KYC
      kycPending: 'Pending KYC',
      kycVerified: 'Verified KYC',
      kycRejected: 'Rejected KYC',
      verify: 'Verify',
      reject: 'Reject',
      rejectReason: 'Rejection reason',
      documentType: 'Document type',
      documentNumber: 'Document number',
      // Withdrawals
      pendingWithdrawals: 'Pending withdrawals',
      approvedWithdrawals: 'Approved withdrawals',
      paidWithdrawals: 'Paid withdrawals',
      totalPending: 'Total pending',
      approve: 'Approve',
      markPaid: 'Mark paid',
      paymentRef: 'Payment reference',
      paymentMethod: 'Payment method',
      system: 'System',
      today: 'Today',
      regenerating: 'Regenerating...',
      regenerateFutureSlots: 'Regenerate future slots',
      protectedSlotsWarning: 'Already distributed or manually edited slots are protected.',
      noSchedule: 'No schedule available',
    },

    // Time
    time: {
      seconds: 's',
      minutes: 'm',
      hours: 'h',
      days: 'd',
      ago: 'ago',
      remaining: 'remaining',
    },
  },
};

export default translations;
